export { Blockquote } from "./blockquote";

export type * from "./blockquote";
